import type { Menu } from '@/menus/types.ts';
export default [
  {
    code: 'CUSTOMS_DECLARATION',
    icon: 'menu-customs-declaration',
    label: '报关',
    path: '/customs-declaration',
  },
] satisfies Menu[];
